import React from 'react';
import './courseTopicNameCard.css'

function C2wCourseTopicNameCard( { obj=null, index=null, isSelected, onClick, setOfflineTopicIndex   } ) {
  return (
    <div className={`C2wCourseTopicNameCard_ctn ${isSelected ? 'selectedTopicCard' : ''} `} onClick={onClick}>
        <div className='C2wTopicHead'>{`Topic ${index + 1}`}</div>
        <div className='C2wTopicTitle'>{obj?.Title}</div>
        <div className={`C2wCircleDiv ${isSelected ? 'selectedCircleDiv' : ''} `}></div>
    </div>
  )
}

export default C2wCourseTopicNameCard